//gets the value of the given name of url parameter
export default function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
}

//Function that changes the url.
export function storeToUrl(data) {
    window.history.pushState("", "", formUrlQuery(data));
}

//forms url based on parameters.
function formUrlQuery(data) {
    return '?' + Object.keys(data).filter(key => data[key]).map(key => key + '=' + data[key]).join('&');
}